export const paths = {
  blog: "/blog",
  blogPosts: "/blog/posts",
  blogPost: "/blog/posts/:slug",
};
